import { createPageCommandsService } from './PageCommandsService.impl';

export const myPageCommandsService = createPageCommandsService();
